// App.jsx
import React, { useEffect, useState } from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaDiscord, FaLinkedinIn, FaTelegramPlane } from "react-icons/fa";
import './footer.css';
import { Link, useNavigate } from "react-router-dom";
import logo from '../../assests/images/horizontal_without_taglinel.png'
import whatsup from '../../assests/whatsup.png';
import QRCode from 'react-qr-code';

function GalaxyBackground() {
  const [stars, setStars] = useState([]);
  const [status, setStatus] = useState('');
  const [formData, setFormData] = useState({
    email: '',
  });

  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const validate = () => {
    const errors = {};
    if (!formData.email || !formData.email.includes('@')) {
      errors.email = 'Valid email required';
    }
    return errors;
  };

  const phoneno = "919343389975"
  const mess = "Hi I am  "
  const wling = `https://wa.me/${phoneno}?text=${encodeURIComponent(mess)}`
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length === 0) {
      try {
        const payload = {
          ...formData,
        };

        const response = await fetch(
          'https://www.tekitsolution.com/email_apis.php?action=contact_footer',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams(payload).toString(),
          }
        );

        const result = await response.json();
        alert('Form submitted successfully!');
        setFormData({
          email: '',
        });
        setMessage('Message sent successfully!');
        setErrors({});
        setStatus('Thanks for subscribing!');
      } catch (error) {
        console.error('Error:', error);
        alert('Something went wrong. Please try again.');
      }
    } else {
      setErrors(validationErrors);
      setStatus('Please enter a valid email');
    }
  };
  // useEffect(() => {
  //     const newStars = Array.from({ length: 8 }).map((_, i) => ({
  //         id: i,
  //         left: Math.random() * 40,  // more horizontal spread
  //         delay: Math.random() * 5,
  //         duration: 5 + Math.random() * 3,
  //         top: Math.random() * 20,   // more vertical spread
  //     }));
  //     setStars(newStars);
  // }, []);
  useEffect(() => {
    const newStars = Array.from({ length: 4 }).map((_, i) => ({
      id: i,
      left: Math.random() * 40,
      delay: Math.random() * 10,
      duration: 8 + Math.random() * 10,
      top: Math.random() * 20,
    }));
    setStars(newStars);
  }, []);
  return (
    <div className="App relative min-h-screen overflow-hidden bg-black text-white">
      {/* Small moving stars background */}
      <div className="stars"></div>

      {/* Three big shooting stars launching together from top-left */}
      <div className="shooting-wrapper">
        {Array.from({ length: 3 }).map((_, i) => (
          <div
            key={i}
            className="shooting-star"
            style={{
              // all three start off-screen at top-left
              top: `-20px`,
              left: `-20px`,
              // stagger their delays slightly so they overlap
              animationDelay: `${i * 0.5}s`,
            }}
          />
        ))}
      </div>
      <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center space-y-6 relative overflow-hidden">
        {/* Shooting Stars */}
        <div className="flex flex-col items-center">
          <img src={logo} className="lg:w-44 w-80 2xl:mt-6 lg:mt-10 mt-10" />
          <h2 className='lg:text-[20px] text-[40px] text-center'>
            Tech Innovation and Skilled Talent, Unified
          </h2>
        </div>
        <p className='lg:text-[26px] font-recoleta pt-8 font-semibold text-[40px] '>Subscribe to the TekBuzz ( Newsletter )</p>
        {stars.map((star) => (
          <div
            key={star.id}
            className="shooting-star absolute"
            style={{
              top: `${star.top}%`,
              left: `${star.left}%`,
              animationDelay: `${star.delay}s`,
              animationDuration: `${star.duration}s`,
            }}
          >
            <div className="star-glow" />
          </div>
        ))}
        {/* <GalaxyBackground /> */}
        {/* UI elements */}
        <div className="flex flex-col space-y-2 items-start">
          <div className="flex items-center mt-4 space-x-2 border border-gray-700 rounded-md bg-[#111] z-10">
            <input
              type="email"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
              placeholder="name@email.com"
              className="bg-transparent pt-4 pl-4 lg:text-[16px] text-[22px] outline-none text-white placeholder-gray-400 py-2"
            />
            <button
              onClick={handleSubmit}
              className="bg-gray-800 pt-4 lg:text-[16px] text-[22px] px-4 py-2 rounded-md hover:bg-gray-700 transition"
            >
              ⮐ Subscribe
            </button>
          </div>
          {status && (
            <p className="text-sm text-red-500">
              {status}
            </p>
          )}
        </div>
        <div className="text-center">
          <h2 className="text-[40px] 2xl:text-[32px]  lg:text-[26px] pt-8 font-bold text-white">TekBlogs .... </h2>
          <div className="flex pt-4 space-x-6 justify-center lg:mb-0 mb-20 z-10">

            <button
              onClick={() => navigate('/blogPage')}
              className="lg:px-12 px-32 lg:py-4 py-8 lg:text-[16px] text-[44px] bg-gray-900 rounded-xl hover:bg-gray-700 transition"
            >
              Blog
            </button>
          </div>

        </div>

        <div className="text-center">
          <h2 className="text-[40px] 2xl:text-[32px]  lg:text-[26px] pt-8 font-bold text-white">Reach Out, We’re Here ✨ </h2>
          <div className="flex pt-4 space-x-6 justify-center lg:mb-0 mb-40 z-10">
            <a target="_blank" href={`https://mail.google.com/mail/?view=cm&fs=1&to=hr@tekitsolution.com`} className="lg:px-12 px-32 lg:py-4 py-8 lg:text-[16px] text-[44px] bg-gray-900 rounded-xl hover:bg-gray-700 transition">Email Us</a>
            <a target="_blank" href={`https://mail.google.com/mail/?view=cm&fs=1&to=hr@tekitsolution.com`} className="lg:px-12 px-32 lg:py-4 py-8 lg:text-[16px] text-[44px] bg-gray-900 rounded-xl hover:bg-gray-700 transition">Call Us</a>

          </div>

        </div>
        <div className="flex z-10 pt-8">
          <Link target="_blank" to='https://www.facebook.com/TekITSoftwares?mibextid=wwXIfr&rdid=6NSH1No8kSI4k0Hn&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F16Mgg7LndZ%2F%3Fmibextid%3DwwXIfr#' className='bg-white hover:ring-2 hover:ring-blue-400 rotate-[-4deg] left-44 top-0 z-30 lg:w-10 w-24 lg:h-10 h-24 flex justify-center p-2 rounded-lg '>
            <img
              src='https://framerusercontent.com/images/WsOrnTcVBswZzpfGscwQvXOqA.svg'
              className='transition-transform duration-300 ease-in-out hover:scale-125   rounded-full'
            />
          </Link>

          <Link target="_blank" to='https://x.com/tekitsoftwares' className='bg-white lg:w-10 w-24 lg:h-10 h-24 rotate-[4deg] flex justify-center p-2 hover:ring-2 hover:ring-blue-400 rounded-lg '>
            <img className='transition-transform duration-300 ease-in-out hover:scale-125   rounded-full' src='https://framerusercontent.com/images/wNjA93SxJyHRsZ1HeZZ7y9xAM4.svg' />
          </Link>
          <Link target="_blank" to='https://www.instagram.com/tekitsoftwares/' className='bg-white lg:w-10 w-24 lg:h-10 h-24 rotate-[-4deg] flex justify-center p-2 hover:ring-2 hover:ring-pink-600 rounded-lg '>
            <img className='transition-transform duration-300 ease-in-out hover:scale-125   rounded-full' src='https://framerusercontent.com/images/yG9VRBszJaaxNfceWbu097Z8hA.svg' />
          </Link>
          <Link target="_blank" to='https://www.youtube.com/@TekITSoftwares ' className='rotate-[4deg] bg-white lg:w-10 w-24 lg:h-10 h-24 flex justify-center p-2 hover:ring-2 hover:ring-red-600 rounded-lg '>
            <img className='transition-transform duration-300 ease-in-out hover:scale-125   rounded-full' src='https://framerusercontent.com/images/BgC7bhN4HhHtKaurUNRrl9WYc.svg' />
          </Link>
          {/* <div className='rotate-[-4deg]  bg-white lg:w-10 w-24 lg:h-10 h-24 flex justify-center p-2 hover:ring-2 hover:ring-blue-600 rounded-lg '>
            <img className='transition-transform duration-300 ease-in-out hover:scale-125   rounded-full' src='https://framerusercontent.com/images/zI0AyM8s3ALn2MBQdYz7GzIcJmo.svg' />
          </div> */}
          <Link target="_blank" to='https://www.linkedin.com/company/tekit-softwares' className='rotate-[-4deg] bg-white lg:w-10 w-24 lg:h-10 h-24 flex justify-center p-2 hover:ring-2 hover:ring-blue-800 rounded-lg '>
            <img className='transition-transform duration-300 ease-in-out hover:scale-125   rounded-full' src='https://framerusercontent.com/images/HII5BEEfK2Gl8LGtH6jbbtVFd4.svg' />
          </Link>
          {/* <div className='rotate-[4deg] bg-white lg:w-10 w-24 lg:h-10 h-24 flex justify-center p-2 hover:ring-2 hover:ring-blue-400 rounded-lg h-10'>
            <img className='transition-transform duration-300 ease-in-out hover:scale-125   rounded-full' src='https://framerusercontent.com/images/AofZHvJcQEhcfWd0lOzSsNDzM.svg' />
          </div> */}
        </div>

        {/* <p className="lg:text-[18px] text-[50px] font-medium z-10">Click to go to the social media handles</p> */}
        {/* href={`https://mail.google.com/mail/?view=cm&fs=1&to=${service.email}`} */}




        <footer className=" text-sm pt-10 font-recoleta">

          <div className="max-w-screen-xl w-[90%] mx-auto px-4 grid grid-cols-1 lg:grid-cols-3 gap-10 pb-6 border-b border-gray-300 mt-10 text-white">

            {/* Left - Offices */}
            <div>
              <h3 className="font-bold text-[54px] lg:text-xl 2xl:text-2xl text-center lg:text-left mt-12 lg:mt-0 mb-2">
                Our Offices
              </h3>
              <p className="text-[40px] lg:text-base 2xl:text-lg text-center lg:text-left leading-relaxed lg:leading-8 mt-14 lg:mt-0">
                India - 5, Samradhi Park, Indore, Madhya Pradesh 452016
              </p>

              <h3 className="font-bold text-[54px] lg:text-xl 2xl:text-2xl text-center lg:text-left mt-20 lg:mt-4 mb-2">
                USA
              </h3>
              <p className="text-[40px] lg:text-base 2xl:text-lg text-center lg:text-left leading-relaxed lg:leading-8 mt-10 lg:mt-0">
                16192 Coastal Highway, City of Lewes, Delaware, USA - 19958
              </p>
            </div>

            {/* Middle - Contact Info */}
            <div>
              <h3 className="font-bold text-[54px] lg:text-xl 2xl:text-2xl text-center lg:text-left mt-12 lg:mt-0 mb-2">
                Sales
              </h3>
              <p className="text-[40px] lg:text-base 2xl:text-lg text-center lg:text-left leading-relaxed lg:leading-8 mt-16 lg:mt-0">
                <span className="font-semibold">Email:</span> sales@tekitsolution.com<br />
                <span className="font-semibold">Phone:</span> +91 - 9343389975
              </p>

              <h3 className="font-bold text-[54px] lg:text-xl 2xl:text-2xl text-center lg:text-left mt-28 lg:mt-3 mb-2">
                HR Process
              </h3>
              <p className="text-[40px] lg:text-base 2xl:text-lg text-center lg:text-left leading-relaxed lg:leading-8 mt-16 lg:mt-0">
                <span className="font-semibold">Email:</span> hr@tekitsolution.com<br />
                <span className="font-semibold">Phone:</span> +91 - 9685308585
              </p>
            </div>

            {/* Right - WhatsApp QR */}
            <div className="flex justify-center items-center">
              <a href="https://wa.me/919343389975" target="_blank" rel="noopener noreferrer">
                <img src={whatsup} alt="WhatsApp QR" className="w-72 lg:w-56" />
              </a>
            </div>

          </div>


          {/* Bottom copyright */}
          <div className="text-center py-4 lg:text-[18px] text-[44px] text-white mt-4 ">
            © 2025 TekIT. All Rights Reserved
          </div>

        </footer>

      </div>

      {/* Your page content */}
      {/* <div className="relative z-10 flex flex-col items-center pt-10"> */}
      {/* …nav, inputs, buttons, etc.… */}
      {/* </div> */}
    </div>
  );
}

export default GalaxyBackground;
